<!--
  --
  -- 車両選択ページ
  --
  -->
<template>
  <c-container form wide>
    <c-book-header>車両を選択</c-book-header>

    <c-book-summary-sheet/>

    <template v-if="blocks.length === 0">
      <c-no-block/>
    </template>

    <template v-else>
      <c-block
        v-for="block in blocks"
        :key="block.id"
        :block="block"
      />
    </template>

  </c-container>
</template>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CBookSummarySheet from '@/pages/book/components/CBookSummarySheet'
import CNoBlock from './CNoBlock'
import CBlock from './CBlock'

import * as api from '@/api'

export default {
  name: 'Car',
  mixins: [
    page('車両選択')
  ],
  components: {
    CBookHeader,
    CBookSummarySheet,
    CNoBlock,
    CBlock
  },

  /**
   * データ取得
   */
  async prepare (to, from, store) {
    const shopID = store.getters['book/shopID']
    const schedule = store.getters['book/schedule']
    const reserveID = store.getters['book/reserveID']

    // 予約可能な車両一覧を取得する
    const resp = await api.getAvailableCars(shopID, schedule.begin, schedule.end, reserveID, [
      'maker',
      'name',

      'classID',
      'className',
      'chargeText',

      'category',
      'categoryName',
      'type',
      'typeName',

      'image',
      'attributes'
    ])

    return {
      cars: resp.data
    }
  },

  props: {
    cars: Array
  },

  computed: {
    blocks () {
      return getBlocks(this.cars)
    }
  }
}

/**
 * 表示に適した形式に変換する
 *
 * @param {Array} data 車両一覧
 * @returns {Array} 表示に適した形式で車両一覧を返す
 */
function getBlocks (data) {
  const blocks = []
  let current = null

  for (let i = 0, len = data.length; i < len; ++i) {
    const car = data[i]
    const id = `${car.category}#${car.classID}`

    if (!current) {
      // 新しく current を作成する
      current = {
        id: id,
        className: car.className,
        categoryName: car.categoryName,
        chargeText: car.chargeText,

        cars: [car]
      }
    } else if (current.id !== id) {
      // current を blocks に追加する
      blocks.push(current)

      current = {
        id: id,
        className: car.className,
        categoryName: car.categoryName,
        chargeText: car.chargeText,

        cars: [car]
      }
    } else {
      // current.cars に car を追加する
      current.cars.push(car)
    }
  }

  if (current) {
    // current を blocks に追加する
    blocks.push(current)
  }

  return blocks
}
</script>
